/**
 * List Schema of ConfigAlerta
 * @author Simpli CLI generator
 */
import {
  Helper,
  Schema,
  FieldSet,
  FieldComponent,
  Component,
} from 'simpli-web-sdk'
import {ConfigAlerta} from '@/model/resource/ConfigAlerta'

/* TODO: review generated schema */
export class ListConfigAlertaSchema extends Schema {
  readonly name = 'ListConfigAlerta'

  readonly fieldSet: FieldSet<ConfigAlerta> = {
    idConfigAlertaPk: (): FieldComponent => ({
      is: Component.Render,
    }),
    responsavel: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: schema.model.responsavel?.$id,
      },
    }),
    ativo: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: Helper.bool(schema.model.ativo),
      },
    }),
  }
}
